import { useToasts } from "../Components/Toasts";
import API from "../Services/API";
import { captureException } from "../Services/Sentry";

const useSimpleWrapper = (callback, successMessage, errorMessage) => {
    const {showSuccess, showError} = useToasts();

    return async (data) => {
        return new Promise((resolve, reject) => {
            callback(data)
                .then((result) => {
                    showSuccess(successMessage);
                    resolve(result);
                })
                .catch((error) => {
                    console.error(error);
                    showError(API.parseErrorResponse(error) ?? errorMessage);
                    reject(error);
                    captureException(error);
                });
        });
    }
}

export {
    useSimpleWrapper
}
